import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'Food Science Teacher | New York, NY',
  text: 'The food processing unit completely changed how my students understand what happens to food before it reaches the store. Every lesson was already structured — I just taught it. My classes feel more professional than ever.'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Foods and Nutrition Teacher | Los Angeles, CA',
  text: 'The case studies saved me more times than I can count in the first month. I used to panic when a lesson plan fell apart. Now I open the case study bank and have a real industry discussion running in under five minutes.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Food Safety Instructor | Dallas, TX',
  text: 'I review the assessment bank before every unit and walk in knowing exactly how I am going to measure learning. 300 questions already written and answered — that is weeks of work I did not have to do.'
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Food Science Teacher | Seattle, WA',
  text: 'The visual glossary gave my students a reference they actually use. Food Science vocabulary is technical — seeing the terms connected to visuals made everything click faster than any definition I could have written.'
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'CTE Foods Teacher | Miami, FL',
  text: 'The food innovation projects were a revelation. My students talked about those projects for weeks after we finished. It felt like a real professional experience — not just a school assignment.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-66" data-mp="3mr591yrg4agd">
      <div className="max-w-6xl mx-auto" data-id="element-67" data-mp="3hp64wmnvt9id">
        <div className="text-center mb-16" data-id="element-68" data-mp="3hslj7n9qeeiq"><h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-69" data-mp="2baopbt8uz7np">⭐ More From Teachers Who Already Have the Library</h2></div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-70" data-mp="26aapuzlbp61a">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-71" data-mp="27t1108n1itjx" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-72" data-mp="23sh1wziwpfv5" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-73" data-mp="1p0f55oc4v2zc">{[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-74" data-mp="1tujdaax4xh20" data-mpi={starIndex} />)}</div>
              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-75" data-mp="1g2mpuk6evvby">“{testimonial.text}”</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-76" data-mp="1k2wuntigwfp8"><div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-77" data-mp="1635i7x7ln7dc">{testimonial.initials}</div><div data-id="element-78" data-mp="1b1fk0qntx67x"><div className="font-bold text-white" data-id="element-79" data-mp="1b174er0bnmt1">{testimonial.name}</div><div className="text-xs text-gold-light" data-id="element-80" data-mp="rfdn5a52y3kp">{testimonial.role}</div></div></div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}